import { useStripeApi, useStripeSdk } from '@frontend/simple-billing'
import { computed } from 'vue'
import { useStore } from 'vuex'

export function useStripe() {
	const store = useStore()
	const stripeApiKey = store.getters['env/getProperty']('stripeApiKey')
	const billingApiHost = store.getters['env/getProperty']('billingApiHost')
	const stripeProductId = store.getters['env/getProperty']('stripeProductId')

	const api = useStripeApi({
		baseURL: billingApiHost + 'v1/api/stripe/'
	})

	const { confirmCardPayment } = useStripeSdk(stripeApiKey)

	const userData = computed(() => ({
		user_id: store.state.user.user_id || '85fe2351-8e48-4fc6-8e89-06ad77429d4f',
		email: store.state.user.email || 'sdf@fssdf.sdffgfd'
	}))

	const createSubscription = async (product) => {
		return await api
			.createSubscription({
				..._castProductToApiParams(product),
				product_id: stripeProductId,
				intro_period_interval: 'month',
				intro_period_interval_count: 0,
				intro_period_amount: 0,
				...userData.value
			})
			.then(async (response) => {
				if (['requires_action'].includes(response.data.result)) {
					await confirmCardPayment(response.data.data.payment_intent_secret, response.data.data.payment_method_id)
				}
				return response.data.data.subscription
			})
			.catch((result) => {
				let data = result.response ? result.response.data : result.error
				return Promise.reject(data)
			})
	}

	return {
		createSubscription
	}
}

function _castProductToApiParams(product) {
	return {
		trial_period_days: product.trial_days,
		trial_period_amount: 0,
		regular_period_interval: 'month',
		regular_period_interval_count: product.duration_months,
		regular_period_amount: product.product_price,
		payment_method_id: product.payment_method_id,
		currency: product.currency
	}
}
